$(document).ready(function() {

    setTimeout(function(){
        var popupShown = Cookies.get('appraisalPopupShown');

        if(popupShown){
            // Cookie found. No action necessary
        } else {
          lastFocus = document.activeElement;
          displayPopup();
        }

        Cookies.set('appraisalPopupShown', 'yes', { expires: 1 });

    }, 7000);

    function displayPopup(){
        $("#appraisal-popup-modal").modal('show');
    }

});